import React from 'react';

/**
 * Used with FormattedMessage/formatMessageAsNode to render bold text
 */
const StrongTag = (...chunks): React.ReactNode => <strong>{chunks}</strong>;

export default StrongTag;
